var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copilot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M22.9253 4.97196C22.5214 3.79244 21.4126 3 20.1658 3L18.774 3C17.3622 3 16.1532 4.01106 15.9033 5.40051L14.4509 13.4782L15.0163 11.5829C15.3849 10.347 16.5215 9.5 17.8112 9.5L23.0593 9.5L25.3054 10.809L27.4705 9.5H26.5598C25.313 9.5 24.2042 8.70756 23.8003 7.52804L22.9253 4.97196Z",
    fill: "url(#paint0_radial_1835_92330)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M9.39637 27.0147C9.79613 28.2011 10.9084 29 12.1604 29H14.5727C16.1772 29 17.4805 27.704 17.4893 26.0995L17.5315 18.4862L16.9699 20.4033C16.6058 21.6461 15.4659 22.5 14.1708 22.5H8.88959L6.96437 21.0214L4.88007 22.5H5.78013C7.03206 22.5 8.14435 23.299 8.54411 24.4853L9.39637 27.0147Z",
    fill: "url(#paint1_radial_1835_92330)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 3H8.81266C5.68767 3 3.81268 7.08916 2.56269 11.1783C1.08177 16.0229 -0.856044 22.5021 4.75017 22.5021H9.66051C10.9615 22.5021 12.105 21.6415 12.4657 20.3915C13.2784 17.5759 14.7501 12.4993 15.9014 8.65192C16.4758 6.73249 16.9543 5.08404 17.6886 4.05749C18.1003 3.48196 18.7864 3 19.7501 3Z",
    fill: "url(#paint2_linear_1835_92330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 3H8.81266C5.68767 3 3.81268 7.08916 2.56269 11.1783C1.08177 16.0229 -0.856044 22.5021 4.75017 22.5021H9.66051C10.9615 22.5021 12.105 21.6415 12.4657 20.3915C13.2784 17.5759 14.7501 12.4993 15.9014 8.65192C16.4758 6.73249 16.9543 5.08404 17.6886 4.05749C18.1003 3.48196 18.7864 3 19.7501 3Z",
    fill: "url(#paint3_linear_1835_92330)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2478 29H23.1852C26.3102 29 28.1852 24.9103 29.4352 20.8207C30.9161 15.9755 32.854 9.49548 27.2477 9.49548H22.3375C21.0364 9.49548 19.893 10.3562 19.5322 11.6062C18.7196 14.4221 17.2479 19.4994 16.0965 23.3474C15.5221 25.2671 15.0436 26.9157 14.3093 27.9424C13.8976 28.518 13.2115 29 12.2478 29Z",
    fill: "url(#paint4_radial_1835_92330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2478 29H23.1852C26.3102 29 28.1852 24.9103 29.4352 20.8207C30.9161 15.9755 32.854 9.49548 27.2477 9.49548H22.3375C21.0364 9.49548 19.893 10.3562 19.5322 11.6062C18.7196 14.4221 17.2479 19.4994 16.0965 23.3474C15.5221 25.2671 15.0436 26.9157 14.3093 27.9424C13.8976 28.518 13.2115 29 12.2478 29Z",
    fill: "url(#paint5_linear_1835_92330)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1835_92330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1872 10.2608) rotate(-136.155) scale(9.27234 9.12445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#4A40D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#2F27A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1835_92330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.1753 21.9482) rotate(50.1613) scale(10.3261 10.1421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A072EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#6C31D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#491D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1835_92330",
    x1: 8.65018,
    y1: 26.6675,
    x2: 10.2455,
    y2: 1.24168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499437,
    stopColor: "#00CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415501,
    stopColor: "#4A94FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764894,
    stopColor: "#7D7DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A071EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1835_92330",
    x1: 9.52186,
    y1: 3,
    x2: 10.3572,
    y2: 22.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#9B9FF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1835_92330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 8.37135) rotate(115.803) scale(22.9133 27.7339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6462E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554591,
    stopColor: "#6462E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A071EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1835_92330",
    x1: 26.1064,
    y1: 8.55983,
    x2: 24.8714,
    y2: 15.0997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B791F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A071EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b25c12c160696e64bf5b3b3d3661583.svg";
export { ForwardRef as ReactComponent };